import palette from './palette';

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(4.7vw, 30px)',
    letterSpacing: '-0.24px',
    lineHeight: '4vw',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(4.3vw, 26px)',
    letterSpacing: '-0.24px',
    lineHeight: '3.5vw',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(3.8vw, 22px)',
    letterSpacing: '-0.06px',
    lineHeight: '3vw',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(3.3vw, 20px)',
    letterSpacing: '-0.06px',
    lineHeight: '2.5vw',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(2.8vw, 16px)',
    letterSpacing: '-0.05px',
    lineHeight: '2vw',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(2.3vw, 14px)',
    letterSpacing: '-0.05px',
    lineHeight: '1.5vw',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: 'min(3.3vw, 18px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(3.7vw, 20px)',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '18px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  body1: {
    color: palette.text.primary,
    fontSize: 'min(3.8vw, 22px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(4.2vw, 24px)',
  },
  body2: {
    color: palette.text.secondary,
    fontSize: 'min(3.8vw, 16px)',
    letterSpacing: '-0.04px',
    lineHeight: 'min(4.2vw, 18px)',
  },
  button: {
    color: palette.text.primary,
    fontSize: '18px',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: 'min(3.3vw, 15px)',
    letterSpacing: '0.33px',
    lineHeight: 'min(3.7vw, 18px)',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: 'min(3.8vw, 16px)',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: 'min(4.2vw, 18px)',
    textTransform: 'uppercase',
  },
  whiteText: {
    color: 'white',
    fontSize: '3.5vw',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
};
